export const CUSTOMER_ROUTE_PREFIX = '/customer';
export const CUSTOMER_LIST_PATH = CUSTOMER_ROUTE_PREFIX;

const CUSTOMER_COLLECTION_STATIC_SEGMENTS = new Set([
  'list',
  'kanban',
  'key-person',
  'existing-system',
  'tag',
]);

export const isCustomerRoute = (pathname: string) =>
  pathname === CUSTOMER_ROUTE_PREFIX ||
  pathname.startsWith(`${CUSTOMER_ROUTE_PREFIX}/`);

export const isCustomerWorkspacePath = (pathname: string) => {
  const segments = pathname.split('/').filter(Boolean);
  if (segments[0] !== 'customer') {
    return false;
  }

  const candidate = segments[1];
  return Boolean(
    candidate && !CUSTOMER_COLLECTION_STATIC_SEGMENTS.has(candidate),
  );
};

export const extractCustomerUuidFromPathname = (pathname: string): string => {
  if (!isCustomerWorkspacePath(pathname)) {
    return '';
  }

  return pathname.split('/').filter(Boolean)[1] || '';
};
